// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_tn-0";